Ext.define('SA.view.sidebar.data.DataFoldersTree', {
    alias: 'widget.data-folders-tree',
    extend: 'Ext.Component',

    baseCls: 'sa-data-folders-tree',

    addChildren(el, folders) {
        var me = this,
            list = document.createElement('ul');

        list.className = 'sa-data-folders-tree-list';

        folders.forEach(folder => {
            var wrap = document.createElement('li'),
                parentPath = el.closest('li[data-folder-path]')?.getAttribute('data-folder-path'),
                item;

            wrap.setAttribute('data-folder-id', folder.id);
            wrap.setAttribute('data-folder-path', parentPath ? `${parentPath} » ${folder.name}` : folder.name);

            wrap.innerHTML = [
                '<button class="sa-data-folders-tree-item sa-data-folders-tree-item-loading" data-folder-id="', folder.id,'">',
                    '<span class="sa-data-folders-tree-item-expander"></span>',
                    '<svg aria-hidden="true" class="sa-data-folders-tree-item-icon-closed">',
                        '<use href="#sa-icon-folder-closed"></use>',
                    '</svg>',
                    '<svg aria-hidden="true" class="sa-data-folders-tree-item-icon-open">',
                        '<use href="#sa-icon-folder-open"></use>',
                    '</svg>',
                    '<span class="sa-data-folders-tree-item-name">',
                        Ext.util.Format.htmlEncode(folder.name),
                    '</span>',
                '</button>'
            ].join('');

            wrap.className = 'sa-data-folders-tree-item-wrap';

            item = wrap.firstChild;

            setFolderExpandable(folder.id, item);

            list.appendChild(wrap);
        });

        el.appendChild(list);

        this.fireEvent('add:folders', folders);

        return list;

        function setFolderExpandable(id, item) {
            me.getChildFolders(id, function(folders) {
                Ext.fly(item).removeCls('sa-data-folders-tree-item-loading');
                Ext.fly(item).addCls('sa-data-folders-tree-item-' + (folders.length ? 'expandable' : 'leaf'));
            });
        }
    },

    getChildFolders(id, callback) {
        this.getChildren(id, children => {
            callback(children && children.filter(child => !child.attribute));
        });
    },

    getChildren(id, callback) {
        var cache = this.folderCache || (this.folderCache = {}),
            children = cache[id];

        if (children) {
            callback(children);
            return;
        }

        SA.data.Tree.getChildFolders(id, this.location).then(folders => {
            if (this.isDestroyed) {
                return;
            }

            cache[id] = folders;

            callback(folders);
        });
    },

    getFolderNode(folder) {
        return this.el.down('.sa-data-folders-tree-item[data-folder-id="' + folder + '"]', true);
    },

    getPath(folder) {
        return this.el.down(`li[data-folder-id=${folder}]`, true).getAttribute('data-folder-path');
    },

    initEvents() {
        this.callParent();

        this.el.on('click', this.onItemClick, this, {delegate: '.sa-data-folders-tree-item'});
        this.el.on('mouseout', this.onItemMouseOut, this, {delegate: '.sa-data-folders-tree-item'});
        this.el.on('mouseover', this.onItemMouseOver, this, {delegate: '.sa-data-folders-tree-item'});
    },

    onItemClick(ev, el) {
        var id = el.getAttribute('data-folder-id'),
            expanded = Ext.fly(el).hasCls('sa-data-folders-tree-item-expanded'),
            skipCollapse = false;

        if (!ev.getTarget('.sa-data-folders-tree-item-expander')) {
            this.select(id);
            skipCollapse = expanded;
        }

        if (skipCollapse) {
            return;
        }

        this.setExpanded(id, !expanded);
    },

    onItemMouseOut(ev, el) {
        Ext.fly(el).removeCls('sa-data-folders-tree-item-over');
    },

    onItemMouseOver(ev, el) {
        Ext.fly(el).addCls('sa-data-folders-tree-item-over');

        this.fireEvent('hover:folder', this, el.getAttribute('data-folder-id'));
    },

    scrollSelectedFolderIntoView() {
        var el = this.el,
            folderEl = el.down('.sa-data-folders-tree-item-selected', true);

        Ext.fly(folderEl).scrollIntoView(el, false);
    },

    select(folder) {
        var oldSelectedEl = this.selectedEl,
            el = this.getFolderNode(folder);

        this.fireEvent('select', this, folder);

        if (oldSelectedEl) {
            Ext.fly(oldSelectedEl).removeCls('sa-data-folders-tree-item-selected');
        }

        if (el) {
            Ext.fly(el).addCls('sa-data-folders-tree-item-selected');
        }

        this.selectedEl = el;
    },

    selectCurrentOrAncestorFolderAtPath(path) {
        var currentFolder = this.el.down('.sa-data-folders-tree-item-selected'),
            targetFolderIndex = path.split(' » ').length - 1,
            ancestorFolders = getAncestorFolders(currentFolder),
            targetFolder = [currentFolder, ...ancestorFolders].reverse()[targetFolderIndex].dom;

        targetFolder.click();

        this.scrollSelectedFolderIntoView();

        function getAncestorFolders(folder) {
            var getParentFolder = folder => folder.parent('.sa-data-folders-tree-list').prev('.sa-data-folders-tree-item'),
                ancestorFolders = [],
                parentFolder;

            while (parentFolder = getParentFolder(folder)) {
                ancestorFolders.push(parentFolder);

                folder = parentFolder;
            }

            return ancestorFolders;
        }
    },

    setExpanded(folder, expanded) {
        this.getChildFolders(folder, children => {
            var el = this.getFolderNode(folder),
                wrap, list, height, start, end;

            if (!el || expanded === Ext.fly(el).hasCls('sa-data-folders-tree-item-expanded')) {
                return;
            }

            if (children && children.length) {
                wrap = el.parentNode;

                list = Ext.fly(wrap).child('.sa-data-folders-tree-list', true);

                if (!list) {
                    list = this.addChildren(wrap, children);
                }

                Ext.fly(el).ifCls(expanded, 'sa-data-folders-tree-item-expanded');

                Ext.fly(list).setStyle({
                    display: null,
                    height: null,
                    transition: 'none'
                });

                height = Ext.fly(list).getHeight();

                if (expanded) {
                    start = 0;
                    end = height;
                }
                else {
                    start = height;
                    end = 0;
                }

                Ext.fly(list).setStyle('height', start + 'px');

                Ext.fly(list).getStyle('height');

                Ext.fly(list).setStyle('transition', 'height 250ms');
                Ext.fly(list).setStyle('height', end + 'px');

                setTimeout(() => {
                    if (expanded !== Ext.fly(el).hasCls('sa-data-folders-tree-item-expanded')) {
                        return;
                    }

                    Ext.fly(list).setStyle({
                        display: expanded ? null : 'none',
                        height: null,
                        transition: null
                    });

                    if (expanded) {
                        this.fireEvent('expanded:folder', folder);
                    }
                }, 400);
            }
            else if (expanded) {
                this.fireEvent('expanded:folder', folder);
            }
        });
    },

    viewFolderAtPath(path, dataset, year, censusRelease, location) {
        var me = this,
            folders = path.split(' » '),
            request = SA.data.Tree.getRootFolders(dataset, year, censusRelease, location),
            deepestFolderId;

        this.location = location;

        return request.then(rootFolders => {
            return new Promise(resolve => {
                this.on('add:folders', onFoldersAdded);
                this.on('expanded:folder', onFolderExpanded);

                this.el.dom.innerHTML = '';

                this.addChildren(this.el.dom, rootFolders);

                function onFoldersAdded(addedFolders) {
                    var nextFolder = folders.shift(),
                        pathExhausted = !folders.length,
                        id = getFolderByName(addedFolders, nextFolder).id;

                    if (pathExhausted) {
                        deepestFolderId = id;

                        me.un('add:folders', onFoldersAdded);
                    }

                    me.select(id);
                    me.setExpanded(id, true);
                }

                function onFolderExpanded(folderId) {
                    if (folderId !== deepestFolderId) {
                        return;
                    }

                    me.un('expanded:folder', onFolderExpanded);

                    resolve();
                }
            });
        });

        function getFolderByName(folders, folderName) {
            return folders.find(folder => folder.name === folderName);
        }
    },

    viewRoot(dataset, year, censusRelease, location) {
        var request = SA.data.Tree.getRootFolders(dataset, year, censusRelease, location);

        this.location = location;

        return request.then(folders => {
            if (this.isDestroyed) {
                return;
            }

            this.el.dom.innerHTML = '';

            this.addChildren(this.el.dom, folders);

            if (folders && folders.length === 1) {
                let id = folders[0].id;

                this.select(id);
                this.setExpanded(id, true);
            }
        });
    }
});
